export const stack = ["Frontend", "Backend", "Full Stack", "Human"] as const;
